import e from "react";
import n from "prop-types";
import r from "@leafygreen-ui/tooltip";
import { css as t, cx as o } from "@leafygreen-ui/emotion";
import { palette as i } from "@leafygreen-ui/palette";
import { Theme as l } from "@leafygreen-ui/lib";
import { useDarkMode as a } from "@leafygreen-ui/leafygreen-provider";

function c(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function f() {
  return f = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }, f.apply(this, arguments);
}

function s(e, n) {
  if (null == e) return {};

  var r,
      t,
      o = function (e, n) {
    if (null == e) return {};
    var r,
        t,
        o = {},
        i = Object.keys(e);

    for (t = 0; t < i.length; t++) {
      r = i[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (t = 0; t < i.length; t++) {
      r = i[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

function u(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

var d,
    p,
    m,
    b,
    y = ["definition", "children", "className", "tooltipClassName", "darkMode"],
    g = t(d || (d = u(["\n  border-radius: 2px;\n  text-decoration: underline dotted 2px;\n  text-underline-offset: 0.125em;\n\n  &:hover {\n    a > * {\n      // Remove the Link underline styles\n      &::after {\n        height: 0;\n      }\n    }\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline-color: ", ";\n    outline-offset: 3px;\n    outline-style: solid;\n    outline-width: 2px;\n  }\n"])), i.blue.light1),
    h = (c(b = {}, l.Light, t(p || (p = u(["\n    text-decoration-color: ", ";\n\n    &:hover,\n    &:focus,\n    &:focus-visible {\n      text-decoration-color: ", ";\n    }\n  "])), i.black, i.black)), c(b, l.Dark, t(m || (m = u(["\n    text-decoration-color: ", ";\n\n    &:hover,\n    &:focus,\n    &:focus-visible {\n      text-decoration-color: ", ";\n    }\n  "])), i.gray.light2, i.gray.light2)), b);

function v(n) {
  var t = n.definition,
      i = n.children,
      l = n.className,
      c = n.tooltipClassName,
      u = n.darkMode,
      d = s(n, y),
      p = a(u),
      m = p.theme,
      b = p.darkMode;
  return e.createElement(r, f({
    justify: "middle",
    spacing: 9,
    className: c,
    darkMode: b
  }, d, {
    trigger: e.createElement("span", {
      tabIndex: 0,
      className: o(g, h[m], l)
    }, i)
  }), t);
}

v.displayName = "InlineDefinition", v.propTypes = {
  definition: n.node.isRequired,
  className: n.string,
  children: n.node
};
export { v as default };